import store from '../vuex'

export default {
    methods: {
        /**
         * 
         * @param featureCode
         * @param forceCheckAuth 是否强制校验权限, 即使当前用户是ADMIN
         * @returns {boolean}
         */
        checkFeature: function (featureCode, forceCheckAuth) {
            if (!forceCheckAuth && store.state.user.userType == "ADMIN") {//管理员类型不受角色权限控制
                return true;
            }
            if (!featureCode) {
                return true;
            }
            //console.log("userf",store.state.userFeature);
            if (!store.state.userFeature) {
                return false;
            }

            var featureStr = store.state.userFeature.join(" ");
            if (featureStr.indexOf(featureCode) != -1) {
                return true;
            } else {
                return false;
            }
        },
        checkDeptAuth: function () {
            alert(666)
        }
    }
}


// WEBPACK FOOTER //
// ./src/util/authentication.js